module.exports = __webpack_public_path__ + "img/Thailand-5.11c3de5a.jpg";